module.exports = __webpack_public_path__ + "static/media/90400.0d5f280d.png";